// extracted by mini-css-extract-plugin
module.exports = {"captchaGroup":"captchaGroup___3bvlz","imgcode":"imgcode___2Y99y"};